<script lang="ts">import { stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { RemoteIcon } from "@infinitro/icons";
let { icon = null, activeTab = false, inactiveTab = false, isWalletButton = false, iconCustomStyles = "", walletIconCustomStyles = "" } = $props();
</script>

{#if typeof icon === 'string'}
	{#if icon.endsWith('.svg') || icon.endsWith('.png') || icon.endsWith('.jpg') || /^(https?:|data:)/.test(icon)}
		<img
			src={icon}
			alt={$t(Verbiage.icon_alt, 'alts')}
			class="icon"
			style={iconCustomStyles}
			class:icon-inactive={inactiveTab}
			class:icon-active={activeTab}
			class:wallet-icon={isWalletButton}
		/>
		{#if isWalletButton}
			<div class="wallet-icon-circle" style={walletIconCustomStyles}></div>
		{/if}
	{:else}
		{#if $stateUi.layout.useRemoteIcons === true && typeof icon === 'string'}
			<RemoteIcon {icon} size={20} />
		{:else}
			<i class={icon} style={iconCustomStyles}></i>
		{/if}
		{#if isWalletButton}
			<div class="wallet-icon-circle" style={walletIconCustomStyles}></div>
		{/if}
	{/if}
{:else if icon != null && typeof icon !== 'string'}
	{@const Icon = icon}
	<span class="icon" style={iconCustomStyles}>
		<Icon hover={activeTab} size={20} />
	</span>
	{#if isWalletButton}
		<div class="wallet-icon-circle" style={walletIconCustomStyles}></div>
	{/if}
{/if}

<style>
	.icon {
		display: flex;
		width: 16px;
		align-items: center;
		justify-content: center
}
	.icon-inactive {
		opacity: 0.6
}
	.icon-inactive:hover {
		opacity: 1
}
	.icon-active {
		opacity: 1
}
	.wallet-icon {
		position: absolute;
		left: 5px;
		top: 50%;
		z-index: 2;
		height: 24px;
		width: 24px;
		--tw-translate-y: -50%;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
	.wallet-icon-circle {
		position: absolute;
		left: 0px;
		z-index: 1;
		margin: 0px;
		height: 38px;
		width: 36px;
		border-radius: 8px 50% 50% 8px;
		padding: 0px;
		background: linear-gradient(207.49deg, #ffffff 4.45%, #999999 117.95%)
}
</style>
